import constants from '../../ahm-constants';

const { URLS } = constants;
export default {
  guides: [
    {
      data: [
        {
          description: 'The nitty gritty of all the important information you need to know about being an ahm member.',
          title: 'Member Guide',
          to: constants.URLS.FILES.MEMBER_GUIDE,
        },
        {
          description: `Including ‘7 Questions to ask your specialists before you go to hospital’`,
          icon: 'external-link-light',
          title: 'Going to hospital',
          to: URLS.HELP.GOING_TO_HOSPITAL,
        },
        {
          description: 'Everything that you need to know about your medical bills before going to hospital.',
          icon: 'external-link-light',
          title: 'Informed Financial Consent',
          to: URLS.HELP.INFORMED_FINANCIAL_CONSENT,
        },
      ],
      link: 'members-guides',
      title: 'Member guides',
    },
    {
      calloutInfo: true,
      data: [
        {
          description: `For any services that cannot be claimed online. You can also use this form to make
          medical gap claims.`,
          title: 'Claim form',
          to: URLS.FILES.CLAIM_FORM,
        },
        {
          description: `Ask your doctor to complete this form to be eligible for exercise program benefits while
          participating in an ahm Health Management Program, or a recognised program offered by an ahm recognised
          provider.`,
          title: 'Health improvement benefits approval form',
          to: URLS.FILES.HEALTH_IMPROVEMENT_BENEFITS_APPROVAL,
        },
        {
          description: `Complete this form if you have received treatment or are going to receive treatment in
          hospital due to an accident and have held your Hospital cover for 2 months or less, or where you want
          to claim under Accident override (check your product guide).`,
          title: 'Accident claim form',
          to: URLS.FILES.ACCIDENT_FORM,
        },
        {
          description: `To apply for the Australian Government Rebate on Private Health Insurance
          please complete and send us this form.`,
          title: 'Rebate form',
          to: URLS.FILES.AUSTRALIAN_GOVERNMENT_REBATE_FORM,
        },
        {
          description: 'Complete this form if you joined ahm health insurance and are switching health insurers.',
          title: 'Transfer certificate request form',
          to: URLS.FILES.TRANSFER_CERTIFICATE_REQUEST_FORM,
        },
        {
          description: `Complete this form to allow another person (Authorised Person) to deal with ahm on
          your behalf.`,
          title: 'Third party authorisation form',
          to: URLS.FILES.THIRD_PARTY_AUTHORISATION_FORM,
        },
        {
          description: 'Complete this form to provide another person access to your claims and personal information.',
          title: 'Personal information and claims consent form',
          to: URLS.FILES.CLAIMS_AND_INFORMATION_CONSENT_FORM,
        },
        {
          description: `Please ask your GP or Specialist to complete this form if you’ve received an insulin pump
          replacement outside of a hospital.`,
          title: 'Insulin pump replacement funding form',
          to: URLS.FILES.INSULIN_PUMP_REPLACEMENT_FUNDING_FORM,
        },
        {
          description: `Please ask your GP or Specialist to complete this form if you’ve received a cochlear speech
          processor replacement outside of a hospital.`,
          title: 'Cochlear speech processor replacement funding form',
          to: URLS.FILES.COCHLEAR_SPEECH_PROCESSOR_REPLACEMENT_FUNDING_FORM,
        },
        {
          description: `Complete this form if you want to set up or update direct debit payment details, 
          change payment frequency or the bank details of the account we pay benefits into.`,
          title: 'Payment form',
          to: URLS.FILES.PAYMENT_FORM,
        },
        {
          description: `Complete this form if you think you might be eligible for an exemption
          from the Lifetime Health Cover loading.`,
          title: 'Lifetime Health Cover loading exemption form',
          to: URLS.FILES.LHC_EXEMPTION_FORM,
        },
        {
          description: `Ask your doctors to complete this form if you want to claim a medical procedure or surgery within 
          the first 12 months of taking out cover or changing your cover to include a new or upgraded service, 
          to confirm the procedure or surgery is not due to a pre-existing condition.`,
          title: 'Pre-existing condition form',
          to: URLS.FILES.PRE_EXISTING_CONDITIONS_FORM,
        },
      ],
      link: 'ahm-health-insurance-forms',
      title: 'Forms',
    },
    {
      data: [
        {
          title: 'Medicare claim form',
          to: URLS.THIRD_PARTY.MEDICARE_CLAIM_FORM,
        },
        {
          title: 'Medicare two-way claim form',
          to: URLS.THIRD_PARTY.MEDICARE_TWO_WAY_CLAIM_FORM,
        },
      ],
      description:
        'If you’ve received a bill from your doctor(s) or recognised provider(s) for any inpatient service, you’ll need to fill in a Medicare claim form and a Two-way claim form to submit your claim to Medicare first. Medicare will then process your forms and send them to us to process your claim.',
      link: 'medicare-hospital-claim-forms',
      title: 'Medicare hospital claim forms',
    },
    {
      data: [
        {
          description: `When joining ahm health insurance you agree to adhere to fund rules We recommend
          that you read our fund rules together with the product guide and Member Guide relevant to your cover.`,
          title: 'Fund Rules',
          to: URLS.FILES.AHM_FUND_RULES,
        },
        {
          description: `This is our industry code which has been created to help you – it requires health insurers
          to give you clear information when dealing with you. All that we do and all that we offer complies with
          the Code.`,
          title: 'The Private Health Insurance Code of Conduct',
          to: URLS.THIRD_PARTY.PRIVATE_HEALTH_INSURANCE_CODE_OF_CONDUCT,
        },
      ],
      link: 'other-docs',
      title: 'Other docs',
    },
  ],
  heading: {
    link: 'combined-cover-product-guides',
    title: 'Product guides',
  },
};
